import React from 'react';
import axios from 'axios';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import router from './Routes';
  import 'bootstrap/dist/css/bootstrap.min.css';
  import './index.css'
import { ContextProvider } from './Views/Context/ContextProvider';
const root = ReactDOM.createRoot(document.getElementById('root'));


//axios.defaults.baseURL="http://192.168.100.30/softwareapisreturn/public/";//its my local ip
//if you want to use on laptop you have to 192.168.100.30:3000 this is how you
//can access your app on laptop and on mobile as well

// if you want to use localhost:3000 then will not work then you have
//to use localhost:8000 port for apis accessing

//axios.defaults.baseURL="https://hassanbookdepo.posreact.com/softwareapis/";
axios.defaults.baseURL="https://azizks.posreact.com/softwareapis/";
//axios.defaults.baseURL="https://gadgetsworld.click/softwareapis/";
//axios.defaults.baseURL="http://localhost:8000/";

axios.defaults.headers.post['Content-Type']='application/json';
axios.defaults.headers.post['Accept']='application/json';
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;
axios.interceptors.request.use(function (config){
const token=localStorage.getItem('ACCESS_TOKEN');
config.headers.Authorization = token ? `Bearer ${token}` : '';

return config;

});
axios.interceptors.response.use((response) => {
  return response
}, (error) => {
  const {response} = error;
  if (response.status === 401) {
    localStorage.removeItem('ACCESS_TOKEN')
    // window.location.reload();
  } else if (response.status === 404) {
    //Show not found
  }

  throw error;
})
root.render(
  <React.StrictMode>
   <ContextProvider>
  <RouterProvider router={router} /> 
  </ContextProvider>
  </React.StrictMode>
);


